import React, { useContext } from 'react'
import CommonModal from './CommonModal'
import LoginForm from './LoginForm'
import { TranslationContext } from '@src/components/translation/TranslationContext'

const TeacherLoginModal = props => {
  const t = useContext(TranslationContext)

  return (
    <CommonModal headerText={t.translate('components.login.log_in_to_classdojo')} {...props}>
      <LoginForm userType="teacher"></LoginForm>
    </CommonModal>
  )
}

export default TeacherLoginModal
